import { DistancePropertyComponent } from '../components/DistancePropertyComponent';
import { PropertySchema } from '../PropertySchema';

export interface DistanceConfiguration {
  inputProps?: {
    max?: 0;
    min?: 0;
  };
  helpButtonTooltip?: string;
}

export const DistanceProperty = new PropertySchema<number | null, DistanceConfiguration>('distance', {
  defaultConfiguration: { required: true },

  component: DistancePropertyComponent,
});
